import { LitElement, css, html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";

import { ApiError, api } from "../api/client";
import { icons } from "../icons";
import { shared } from "../styles/shared";

@customElement("page-login")
export class PageLogin extends LitElement {
  @state() private error = "";
  @state() private busy = false;

  static styles = [
    shared,
    css`
      :host { display: block; }
      .wrap { min-height: calc(100vh - 120px); display: flex; align-items: center; justify-content: center; padding: 40px 16px; }
      .card { width: 100%; max-width: 420px; }
      .brand { display: flex; align-items: center; gap: 10px; font-weight: 700; font-size: 17px; margin-bottom: 28px; }
      .brand-mark { width: 32px; height: 32px; border-radius: 9px; background: linear-gradient(155deg, var(--blue-500), var(--navy-900)); display: flex; align-items: center; justify-content: center; }
      h1 { font-size: 22px; font-weight: 800; letter-spacing: -.02em; color: var(--navy-950); margin-bottom: 6px; }
      p { color: var(--slate-600); font-size: 14px; margin-bottom: 22px; }
      form { display: flex; flex-direction: column; gap: 14px; }
    `,
  ];

  private async submit(event: SubmitEvent) {
    event.preventDefault();
    const token = String(new FormData(event.target as HTMLFormElement).get("token") ?? "").trim();
    if (!token) return;
    this.busy = true;
    this.error = "";
    try {
      await api.login(token);
      this.dispatchEvent(new CustomEvent("logged-in", { bubbles: true, composed: true }));
    } catch (err) {
      this.error = err instanceof ApiError ? err.message : "Connexion impossible";
    } finally {
      this.busy = false;
    }
  }

  render() {
    return html`<div class="wrap">
      <div class="card card-padded fade-up">
        <div class="brand"><span class="brand-mark">${icons.brand}</span>Laundering</div>
        <h1>Connexion</h1>
        <p>Saisissez le token d'accès personnel qui vous a été remis.</p>
        <form @submit=${this.submit}>
          <div class="field">
            <label for="token">Token d'accès</label>
            <input class="input mono" id="token" name="token" type="password" autocomplete="off" required aria-invalid=${this.error ? "true" : "false"} />
          </div>
          ${this.error ? html`<div class="alert alert-error" role="alert">${icons.alert}<span>${this.error}</span></div>` : nothing}
          <button class="btn btn-primary btn-block" ?disabled=${this.busy}>
            ${this.busy ? html`<span class="spinner"></span>` : nothing} Se connecter
          </button>
        </form>
      </div>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "page-login": PageLogin;
  }
}
